import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/logo3.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      {/* Main Navbar */}
      <div className="header-main">
        <div className="container header-container">
          <a href="/" className="logo">
            <img src={logo} alt="Bright Angel Logo" className="logo-img" />
            <div className="logo-text-wrapper">
              <span className="company-name">
                <span style={{ color: 'var(--color-primary-blue)' }}>BRIGHT</span>{' '}
                <span style={{ color: 'var(--color-secondary-green)' }}>ANGEL</span>
              </span>
              <span className="company-motto">Your Gateway to Global Education</span>
            </div>
          </a>

          <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle Navigation">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
              {isMenuOpen ? (
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              ) : (
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
              )}
            </svg>
          </button>

          <div className={`header-actions ${isMenuOpen ? 'open' : ''}`}>
            <nav className="nav">
              <ul>
                <li><a href="/" onClick={() => setIsMenuOpen(false)}>Home</a></li>
                <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a></li>
                <li><a href="#services" onClick={() => setIsMenuOpen(false)}>Our services</a></li>
                <li><a href="#destinations" onClick={() => setIsMenuOpen(false)}>Study Destination </a></li>
                <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact us</a></li>
              </ul>
            </nav>
            <a href="https://wa.me/94777970498" className="btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.878-.788-1.472-1.761-1.645-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 21.666c-1.571 0-3.11-.422-4.46-1.22l-.32-.19-3.32.871.884-3.238-.208-.33a9.66 9.66 0 0 1-1.47-5.186C3.106 6.845 7.098 2.85 12 2.85c2.396 0 4.648.934 6.34 2.626 1.693 1.692 2.625 3.945 2.625 6.341 0 5.127-3.991 9.849-8.965 9.849zm0-19.982C6.46 1.684 1.95 6.191 1.95 11.75c0 1.767.461 3.486 1.336 5l-1.397 5.111 5.228-1.373a9.98 9.98 0 0 0 4.883 1.26h.004c5.541 0 10.051-4.506 10.051-10.066 0-2.686-1.045-5.21-2.942-7.108A10.024 10.024 0 0 0 12 1.684z"/>
              </svg>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.1}}>
                <span style={{fontSize: '0.7rem', fontWeight: 500}}>Free Consultation</span>
                <span style={{fontSize: '1rem'}}>WhatsApp Now</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
